var map = {
	"./Testimonial-image.png": 320,
	"./black-beautiful-ladies-smiling.png": 994,
	"./custom-underline.png": 51,
	"./customers/user1.png": 200,
	"./customers/user2.png": 2,
	"./customers/user3.png": 120,
	"./logo.svg": 835,
	"./social": 843,
	"./social/": 843,
	"./social/fb.svg": 678,
	"./social/ig.svg": 978,
	"./social/index": 843,
	"./social/index.ts": 843,
	"./social/li.svg": 429,
	"./social/tw.svg": 410,
	"./subscribe-banner.png": 21,
	"./vendors/user1.png": 993,
	"./vendors/user2.png": 376,
	"./vendors/user3.png": 906,
	"./vendors/user4.png": 405,
	"./vendors/user5.png": 495,
	"./vendors/user6.png": 811,
	"./vendors/user7.png": 694,
	"./vendors/user8.png": 498,
	"./vendors/user9.png": 137,
	"./woman-shoppingbag-card.png": 788,
	"./🎉.png": 532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;